import React, { FC } from 'react';
import { useTranslation } from 'react-i18next';
import { Button, Dialog, Heading, Paragraph } from '@digdir/designsystemet-react';

import { ButtonWrapper } from '../screens/registrationV2025/pages/solceller/form/components/styledComponents';

interface ConfirmDialogProps {
  isOpen: boolean;
  onConfirm: () => void;
  onCancel: () => void;
  title: string;
  content: string;
  isLoading?: boolean;
}

export const ConfirmDialog: FC<ConfirmDialogProps> = ({ isOpen, onConfirm, onCancel, title, content, isLoading }) => {
  const { t } = useTranslation();

  return (
    <Dialog open={isOpen} onClose={onCancel}>
      <Dialog.Block>
        <Heading level={1} data-size="sm">
          {title}
        </Heading>
        <Paragraph>{content}</Paragraph>
        <ButtonWrapper>
          <Button variant="primary" onClick={onCancel} disabled={isLoading}>
            {t('cancel')}
          </Button>

          <Button variant="secondary" onClick={onConfirm} loading={isLoading}>
            {t('confirm')}
          </Button>
        </ButtonWrapper>
      </Dialog.Block>
    </Dialog>
  );
};
